import { useCallback, useSyncExternalStore } from 'react';

const canMatch = () => typeof window.matchMedia === 'function';

/** Whether a CSS media query matches now, tracking changes (window resize, device rotation). */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (!canMatch()) return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(subscribe, () => canMatch() && window.matchMedia(query).matches);
}
